<template>
	<div class="form-component-container w-full" ref="formComponent">
		<div class="form-success w-full text-xl text-center my-8 font-bold" v-if="successMsg" v-html="successMsg"></div>
		<div class="flex flex-wrap" :id="'form'+id" v-if="! successMsg">
			<div class="fatal-error" v-if="fatalError">{{ t.fatalError }}</div>
			<template v-for="(field, index) in form.fields" :key="index">
                <div :class="'field-item field-width-'+field.width+isHoneypot(field)">		
    				<div class="field-label" v-if="fieldLabel(field)">
                        {{ fieldLabel(field) }}
                        <span v-if="field.prepend" v-html="field.prepend"></span>
                    </div>
    				<input-component
    					v-if="field.type == 'text' && field.input_type == 'text'"
    					v-model="submit[field.handle]"
    					:name="field.handle"
    					:errors="errors[field.handle]"
    				/>
                    <date-component
    					v-if="field.type == 'text' && field.input_type == 'date'"
    					v-model="submit[field.handle]"
    					:name="field.handle"
    					:selection-mode="checkPlacehoderForRange(field)"
    					:errors="errors[field.handle]"
    				/>
    				<textarea-component
    					v-if="field.type == 'textarea'"
    					v-model="submit[field.handle]"
    					:name="field.handle"
    					:errors="errors[field.handle]"
    				/>
                    <select-component
                        v-if="field.type == 'select'"
                        v-model="submit[field.handle]"
                        :name="field.handle"
                        :options="createOptions(field)"
                        :placeholder="t.pleaseSelect"
                        :filter="(field.handle == 'country' ? true : false)"
                        :errors="errors[field.handle]"
                    />
                    <checkbox-component
                        v-if="field.type == 'checkboxes'"
                        v-model="submit[field.handle]"
                        :name="field.handle"
                        :options="createOptions(field)"
                        :errors="errors[field.handle]"
                        :t="t"
                    />
                </div>
			</template>
            <div class="field-item submit-button mt-6">
                <button class="button-submit w-full py-4 px-8 text-lg" :disabled="disableSubmit" @click="submitForm">
                    <span v-html="label"></span>
                </button>
            </div>
			
		</div>
	</div>
</template>

<script>
import FormHandler from '../../mixins/FormHandler.vue'

import InputComponent from './InputComponent.vue'
import TextareaComponent from './TextareaComponent.vue'
import SelectComponent from './SelectComponent.vue'
import CheckboxComponent from './CheckboxComponent.vue'
import DateComponent from './DateComponent.vue'

export default {
    props: {
        'form': Object,
        'countries': Object,
        't': Object,
        'id': String
    },

    components: {
    	InputComponent,
    	TextareaComponent,
        SelectComponent,
        CheckboxComponent,
        DateComponent,
    },

    mixins: [FormHandler],

    computed: {
        label() {
            return (this.disableSubmit ? this.t.sending : this.t.send)
        }
    },

    mounted() {
        this.$nextTick(() => this.$refs.formComponent.style.minHeight = this.$refs.formComponent.clientHeight+'px')
    },
   
};
</script>